import { render, staticRenderFns } from "./WarrantiesPage.vue?vue&type=template&id=f13c17c8&scoped=true&"
import script from "./WarrantiesPage.vue?vue&type=script&lang=js&"
export * from "./WarrantiesPage.vue?vue&type=script&lang=js&"
import style0 from "./WarrantiesPage.vue?vue&type=style&index=0&id=f13c17c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13c17c8",
  null
  
)

export default component.exports